import { Route, Redirect, Switch } from "react-router-dom";
import Login from "../components/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import UgglaScholarshipApp from "../components/Uggla2025/ScholarshipApp";
import UgglaInitialInformationPage from "../components/Uggla2025/InitialInformationPage";
import VerificationBypassPage from "../components/VerificationBypassPage";
import ApplicationEndedPage from "../components/ApplicationEndedPage";
import InitialLandingPage from "../components/InitialLandingPage";

export const getRoutes = (
  isLoggedIn,
  scholarshipId,
  isActive,
  scholarshipType
) => {
  const LoginIfActive = isActive ? Login : ApplicationEndedPage;
  const LoginLandingPage =
    scholarshipType != null && scholarshipId != null
      ? LoginIfActive
      : InitialLandingPage;

  // TODO: This should be a landing page initially
  let ScholarshipAppPage = UgglaScholarshipApp;
  if (scholarshipType === "uggla-family-scholarship") {
    ScholarshipAppPage = UgglaScholarshipApp;
  }

  return (
    <Switch>
      <Route path="/uggla-family-scholarship">
        {isActive ? (
          <UgglaInitialInformationPage
            scholarshipType="uggla-family-scholarship"
            scholarshipId={scholarshipId}
          />
        ) : (
          <ApplicationEndedPage />
        )}
      </Route>
      <Route path="/login">
        {isLoggedIn ? (
          <Redirect to={`/scholarship/${scholarshipId}/`} />
        ) : (
          <LoginLandingPage scholarshipType={scholarshipType} />
        )}
      </Route>

      <Route path="/login_ext/:token">
        {isLoggedIn ? (
          <Redirect to={`/scholarship/${scholarshipId}/`} />
        ) : (
          <VerificationBypassPage scholarshipType="uggla-family-scholarship" />
        )}
      </Route>
      <ProtectedRoute path={`/scholarship/${scholarshipId}/`}>
        <ScholarshipAppPage scholarshipId={scholarshipId} />
      </ProtectedRoute>
      <Route path="*">
        <InitialLandingPage />
      </Route>
    </Switch>
  );
};
